import {NgModule} from '@angular/core';
import {AppCardComponent} from './card.component';
import {CoreModule} from '@core/core.module';
import {SharedModule} from '@shared/shared.module';
import {AppCardSideLineModule} from '@component/card/card-side-line/card-side-line.module';

@NgModule({
    declarations: [
        AppCardComponent,
    ],
    imports: [
        CoreModule,
        SharedModule,
        AppCardSideLineModule,
    ],
    exports: [
        AppCardComponent,
    ],
})
export class AppCardModule {}
